
import React from 'react';
import PropTypes from 'prop-types';
import './styles/RefundPolicyDialog.scss';
import { Modal } from 'react-bootstrap';
import DEFAULT_REFUND_POLICY from 'lib/defaultRefundPolicyText';


export default function RefundPolicyDialog({ refundPolicyText, show, onHide, onContactUsClick }) {
    const policyText = (refundPolicyText) 
        ? refundPolicyText 
        : DEFAULT_REFUND_POLICY;
    return (
        <Modal show={show} onHide={onHide} className="eg-modal drmType-modal merchant-modal" centered backdrop="static">
            <Modal.Header closeButton>
                <Modal.Title>
                    <h2>Refund Policy</h2>
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <p className="f17 t-qblue margin-top-20 margin-bottom-30">{policyText}</p>
                <button 
                    className="btn btn-md btn-primary" 
                    onClick={() => {
                        onContactUsClick();
                    }} 
                    style={{
                        display: 'block'
                    }}
                >Contact Support</button>       
            </Modal.Body>
        </Modal>
    );
}
RefundPolicyDialog.propTypes = {
    refundPolicyText: PropTypes.string,
    show: PropTypes.bool,
    onHide: PropTypes.func,
    onContactUsClick: PropTypes.func
};
